import React from "react";
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from "react-icons/io";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { extractDate } from "../../../Components/Functions/date.fun";

const getArrowByOderType = (item, ordersTallyOf) => {
  if (ordersTallyOf === "Kryzen-CNF") {
    if (item?.orderType?.endsWith("to cnf")) {
      return (
        <IoIosArrowRoundDown className="me-2 fs-2" style={{ color: "green" }} />
      );
    } else {
      return (
        <IoIosArrowRoundUp className="me-2 fs-2" style={{ color: "red" }} />
      );
    }
  } else if (ordersTallyOf === "Kryzen") {
    if (item?.orderType?.endsWith("to kryzen")) {
      return (
        <IoIosArrowRoundDown className="me-2 fs-2" style={{ color: "green" }} />
      );
    } else {
      return (
        <IoIosArrowRoundUp className="me-2 fs-2" style={{ color: "red" }} />
      );
    }
  } else if (ordersTallyOf === "Farmers") {
    if (item?.orderType?.endsWith("to farmer")) {
      return (
        <IoIosArrowRoundDown className="me-2 fs-2" style={{ color: "green" }} />
      );
    } else {
      return (
        <IoIosArrowRoundUp className="me-2 fs-2" style={{ color: "red" }} />
      );
    }
  }
};

const OrdersRevenueTable = ({
  ordersTallyOf,
  ordersTally,
  currentPage,
  itemsPerPage,
}) => {
  const tableHead = ["Sr.", "Order Id", "date", "credit", "revenue"];

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {ordersTally?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{item?.id}</td>
                <td>
                  {getArrowByOderType(item, ordersTallyOf)}
                  <b>{item?.orderID || "N/A"}</b>
                </td>
                <td>{extractDate(item?.createdAt)}</td>
                <td className="text-success">
                  {item?.credit ? roundOffCost(item?.credit) : "---"}
                </td>

                <td className={"text-success"}>
                  {item?.balance ? roundOffCost(item?.balance) : "---"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default OrdersRevenueTable;
